export enum EStatusTarefaPessoal {
  Aberta = 1,
  Concluida = 2,
  Arquivada = 3,
}
